import { ProductWithSkusProps } from '../../propTypes/product';
import styles from './ProductIntro.module.scss';
import { formatter } from '../utility';
import Image from '@polydice/icook-image-helper';
import shieldIcon from 'images/shield.png';
import Button from '@polydice/ui/dist/Button';
import { triggerSimpleDialog } from '@polydice/ui/dist/Dialog';
import classNames from 'classnames';

const textMap = {
  guarantee: {
    iCook:
      '在愛料理市集上購物的消費者，皆可依消保法享有商品貨到次日起七天猶豫期的權益，七天猶豫期可無條件退貨（生鮮食品、易腐敗食品除外）',
    cool3c:
      '在 Cool3c 市集上購物的消費者，皆可依消保法享有商品貨到次日起七天猶豫期的權益，七天猶豫期可無條件退貨'
  },
  returnUrl: {
    iCook:
      'https://help.icook.tw/hc/zh-tw/sections/206153247-%E9%80%80%E6%8F%9B%E8%B2%A8-%E9%80%80%E6%AC%BE',
    cool3c:
      'https://cool3c.freshdesk.com/support/solutions/folders/150000291908'
  },
  promise: {
    iCook: (
      <>
        愛料理市集為了提供消費者安心購買的環境，我們承諾，若在我們平台下單購買商品，廠商未出貨，愛料理將
        <strong>協助您退款100% 的款項，請您安心選購</strong>。
      </>
    ),
    cool3c: (
      <>
        Cool3c
        市集為了提供消費者安心購買的環境，我們承諾，若在我們平台下單購買商品，廠商未出貨，Cool3c
        市集將
        <strong>協助您退款100% 的款項，請您安心選購</strong>。
      </>
    )
  },
  about: {
    iCook:
      '愛料理為台港澳最大的食譜平台，同時也是實體經營、合法開立發票的台灣公司，從2011 年創辦至今，有超過500萬用戶愛用，台灣女性中每 3 人就有 1 人是iCook 愛料理的使用者。',
    cool3c:
      'Cool3c 隸屬於關鍵評論媒體集團， 以 3C 新品資訊、產品開箱評測，提供市場上最新、最完整的科技生活內容，Cool3C 市集以大人の酷東西為概念，打造市場最有趣的生活科技選品市集。'
  },
  aboutUrl: {
    iCook: 'https://newsroom.icook.tw/',
    cool3c: 'https://www.tnlmediagene.com/media/cool3c'
  },
  aboutUrlText: {
    iCook: '愛料理的詳細介紹',
    cool3c: 'Cool3c 的詳細介紹'
  }
};

const ProductIntroTerms = ({ triggerClose, isCool3c }) => {
  const genText = (name) => {
    return isCool3c ? textMap[name].cool3c : textMap[name].iCook;
  };

  return (
    <>
      <article className={styles.productIntroArticle}>
        <header className={styles.productIntroArticleTitle}>
          <span role="img" aria-label="check">
            ✅
          </span>
          7天鑑賞期
        </header>
        <p className={styles.productIntroArticleContent}>
          {genText('guarantee')}
        </p>
        <footer>
          <a
            href={genText('returnUrl')}
            target="_blank"
            rel="noreferrer"
            className={styles.productIntroArticleLink}
          >
            詳細退換貨說明
          </a>
        </footer>
      </article>
      <article className={styles.productIntroArticle}>
        <header className={styles.productIntroArticleTitle}>
          <span role="img" aria-label="check">
            ✅
          </span>
          未出貨保證退款
        </header>
        <p className={styles.productIntroArticleContent}>
          {genText('promise')}
        </p>
      </article>
      <article className={styles.productIntroArticle}>
        <header className={styles.productIntroArticleTitle}>關於我們</header>
        <p className={styles.productIntroArticleContent}>{genText('about')}</p>
        <footer>
          <a
            href={genText('aboutUrl')}
            target="_blank"
            rel="noreferrer"
            className={styles.productIntroArticleLink}
          >
            {genText('aboutUrlText')}
          </a>
        </footer>
      </article>
      <Button
        styleType="contained"
        color="secondary"
        size="sm"
        fullWidth={true}
        onClick={triggerClose}
      >
        我瞭解了
      </Button>
    </>
  );
};

const openDialog = (isCool3c) => {
  triggerSimpleDialog({
    title: '安心購買',
    isPassiveClose: true,
    children: <ProductIntroTerms isCool3c={isCool3c} />
  });
};

const ProductIntro = ({ product, darkMode, isCool3c }) => {
  const {
    brand_name,
    name,
    subtitle,
    description,
    selling_program_id,
    fundraising_name,
    fundraising_amount,
    available_at
  } = product;
  const isFundraisingProduct = selling_program_id === 2;
  const isAvailable = new Date(available_at) <= new Date();

  return (
    <section className={styles.productIntro}>
      <span
        className={classNames(styles.productIntroBrand, {
          'dark-mode': darkMode
        })}
      >
        {brand_name}
      </span>
      <div className={styles.productIntroTitle}>
        {isFundraisingProduct && !isAvailable && (
          <span
            className={classNames(styles.productIntroTitleBadge, {
              'dark-mode': darkMode
            })}
          >
            預購
          </span>
        )}
        <h1
          className={classNames(styles.productIntroTitleName, {
            'dark-mode': darkMode
          })}
        >
          {name}
        </h1>
      </div>
      <strong
        className={classNames(styles.productIntroSlogan, {
          'dark-mode gray2-color': darkMode
        })}
      >
        {subtitle}
      </strong>
      <p
        className={classNames(styles.productIntroDescription, {
          'dark-mode': darkMode
        })}
      >
        {description}
      </p>
      {fundraising_name && fundraising_amount && (
        <p
          className={classNames(styles.productIntroFundraising, {
            'dark-mode': darkMode
          })}
        >
          <i
            className={`icon-shopping-bag-regular ${styles.productIntroFundraisingIcon}`}
          />
          在
          <strong className={styles.productIntroFundraisingName}>
            {fundraising_name}
          </strong>
          已熱賣突破
          <strong
            className={classNames(styles.productIntroFundraisingNumber, {
              'dark-mode blue-color': darkMode
            })}
          >
            {`$${formatter(fundraising_amount)}萬`}
          </strong>
        </p>
      )}
      <button
        className={classNames(styles.productIntroTerm, {
          'dark-mode gray-bgc no-border': darkMode
        })}
        // className={styles.productIntroTerm}
        onClick={() => openDialog(isCool3c)}
        aria-label="terms"
      >
        <div
          className={classNames(styles.productIntroTermBadge, {
            'dark-mode gray-bgc no-border': darkMode
          })}
        >
          <Image
            src={shieldIcon}
            width={16}
            height={16}
            alt="shield"
            className={styles.productIntroTermBadgeIcon}
          />
          安心選購
        </div>
        <div
          className={classNames(styles.productIntroTermDetail, {
            'dark-mode dark-blue-bgc': darkMode
          })}
        >
          7天鑑賞期，未出貨保證退款
        </div>
      </button>
    </section>
  );
};

ProductIntro.propTypes = {
  product: ProductWithSkusProps.isRequired
};

export default ProductIntro;
